// Mock data for Studio Batisteli Landing Page

export const heroData = {
  slogan: "Regeneração capilar que transforma vidas",
  subtitle: "Recupere sua autoestima com o exclusivo Protocolo Cills de reconstrução capilar. Sobrancelhas, barba e cabelo com resultados comprovados.",
  ctaText: "AGENDE A SUA AVALIAÇÃO AGORA",
  heroImage: "https://customer-assets.emergentagent.com/job_protocolo-cills/artifacts/one21ogt_Design%20sem%20nome%20%281%29.png"
};

export const protocolData = {
  title: "Protocolo Cills",
  subtitle: "A Ciência da Regeneração Capilar",
  description: "O Protocolo Cills é uma técnica revolucionária e não cirúrgica de reconstrução capilar que age diretamente na raiz do problema. Com resultados visíveis e duradouros, este método exclusivo regenera folículos capilares de forma natural e segura.",
  benefits: [
    "100% não cirúrgico e indolor",
    "Resultados visíveis a partir da 3ª sessão",
    "Técnica cientificamente comprovada",
    "Tratamento personalizado para cada caso"
  ],
  image: "https://customer-assets.emergentagent.com/job_protocolo-cills/artifacts/uvuglt5f_%40sbatisteli.regeneacaocapilar.jpg"
};

export const servicesData = [
  {
    id: 1,
    title: "Regeneração de Sobrancelhas",
    description: "Recupere sobrancelhas falhadas ou ralas com o Protocolo Cills. Resultados naturais e permanentes.",
    icon: "Sparkles",
    image: "https://customer-assets.emergentagent.com/job_protocolo-cills/artifacts/tkj74b3e_Design%20sem%20nome%20%282%29.png"
  },
  {
    id: 2,
    title: "Regeneração de Barba",
    description: "Preencha falhas na barba e conquiste a aparência que sempre desejou. Tratamento masculino especializado.",
    icon: "User",
    image: "https://customer-assets.emergentagent.com/job_protocolo-cills/artifacts/f88v4805_%40studiobatisteli.regeneracaocapilar04.jpg"
  },
  {
    id: 3,
    title: "Regeneração Capilar",
    description: "Recupere áreas com rarefação capilar ou calvície. Protocolo eficaz para homens e mulheres.",
    icon: "Zap",
    image: "https://customer-assets.emergentagent.com/job_protocolo-cills/artifacts/ddyae38y_%40studiobatisteli.regeneracaocapilar06.jpg"
  }
];

export const advantagesData = [
  {
    id: 1,
    title: "Avaliação",
    description: "Agende a Sua Sessão de Avalição e conheça em detalhes o protocolo",
    icon: "CheckCircle"
  },
  {
    id: 2,
    title: "Pagamento Facilitado",
    description: "Parcelamento em até 12x para você realizar seu tratamento sem preocupações.",
    icon: "CreditCard"
  },
  {
    id: 3,
    title: "Atendimento Personalizado",
    description: "Cada protocolo é desenvolvido especialmente para suas necessidades individuais.",
    icon: "Heart"
  },
  {
    id: 4,
    title: "Próximo a Você",
    description: "6 unidades em bairros estratégicos de São Paulo, todas próximas ao metrô.",
    icon: "MapPin"
  },
  {
    id: 5,
    title: "Profissionais Especializados",
    description: "Equipe altamente treinada e certificada no Protocolo Cills.",
    icon: "Award"
  },
  {
    id: 6,
    title: "Resultados Comprovados",
    description: "Centenas de clientes satisfeitos com transformações reais e duradouras.",
    icon: "Star"
  }
];

export const locationsData = [
  {
    id: 1,
    name: "Vila Mariana",
    street: "Rua Domingos de Morais",
    number: "2781",
    neighborhood: "Vila Mariana",
    cep: "04035-001",
    phone: "(11) 97827-3924",
    schedule: "Segunda-Feira",
    hours: "09:00 às 18:00",
    icon: "MapPin"
  },
  {
    id: 2,
    name: "Moema",
    street: "Av. Ibirapuera",
    number: "2120",
    neighborhood: "Indianópolis",
    cep: "04028-001",
    phone: "(11) 97827-3924",
    schedule: "Terça-Feira",
    hours: "09:00 às 18:00",
    icon: "MapPin"
  },
  {
    id: 3,
    name: "Tatuapé",
    street: "Rua Bom Sucesso",
    number: "220",
    neighborhood: "Cidade Mãe do Céu",
    cep: "03305-000",
    phone: "(11) 97827-3924",
    schedule: "Quarta-feira",
    hours: "09:00 às 18:00",
    icon: "MapPin"
  },
  {
    id: 4,
    name: "Perdizes",
    street: "Av. Antártica",
    number: "675",
    neighborhood: "Água Branca",
    cep: "05003-020",
    phone: "(11) 97827-3924",
    schedule: "Quinta-Feira",
    hours: "09:00 às 18:00",
    icon: "MapPin"
  },
  {
    id: 5,
    name: "Paulista",
    street: "Rua Manuel da Nóbrega",
    number: "354",
    neighborhood: "Jd. Paulista",
    cep: "04001-001",
    phone: "(11) 97827-3924",
    schedule: "Sexta-feira",
    hours: "09:00 às 18:00",
    icon: "MapPin"
  },
  {
    id: 6,
    name: "Vila Madalena",
    street: "Rua Amália de Noronha",
    number: "151",
    neighborhood: "Pinheiros",
    cep: "05410-010",
    phone: "(11) 97827-3924",
    schedule: "Sábado",
    hours: "09:00 às 14:00",
    icon: "MapPin"
  }
];

export const beforeAfterData = [
  {
    id: 1,
    image: "https://customer-assets.emergentagent.com/job_protocolo-cills/artifacts/ynaeopcp_37-sobrancelha-protocolo-cills.jpg",
    treatment: "Regeneração de Sobrancelhas",
    duration: "Protocolo Cills"
  },
  {
    id: 2,
    image: "https://customer-assets.emergentagent.com/job_protocolo-cills/artifacts/odvgzrcx_34-sobrancelha-protocolo-cills.jpg",
    treatment: "Regeneração de Sobrancelhas",
    duration: "Protocolo Cills"
  },
  {
    id: 3,
    image: "https://customer-assets.emergentagent.com/job_protocolo-cills/artifacts/cvm2wqr1_10-cabelo-protocolo-cills.jpg",
    treatment: "Regeneração Capilar",
    duration: "Protocolo Cills"
  },
  {
    id: 4,
    image: "https://customer-assets.emergentagent.com/job_protocolo-cills/artifacts/tpvt6ahw_20-cabelo-protocolo-cills.jpg",
    treatment: "Regeneração Capilar",
    duration: "Protocolo Cills"
  },
  {
    id: 5,
    image: "https://customer-assets.emergentagent.com/job_protocolo-cills/artifacts/bh93f2vb_barba_03_protocolo_cilss.jpg",
    treatment: "Regeneração de Barba",
    duration: "Protocolo Cills"
  },
  {
    id: 6,
    image: "https://customer-assets.emergentagent.com/job_protocolo-cills/artifacts/4x5e8to3_barba_01_protocolo_cilss.jpg",
    treatment: "Regeneração de Barba",
    duration: "Protocolo Cills"
  }
];

export const testimonialsData = [
  {
    id: 1,
    name: "Ricardo Silva",
    age: 35,
    treatment: "Regeneração Capilar",
    text: "Após anos sofrendo com a calvície, encontrei no Studio Batisteli a solução que eu procurava. O Protocolo Cills realmente funciona! Minha autoestima voltou e me sinto renovado.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1694185749831-442ae46b5446?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHxjb25maWRlbnQlMjBwcm9mZXNzaW9uYWwlMjBicmF6aWxpYW4lMjBwZXJzb24lMjBwb3J0cmFpdHxlbnwwfHx8fDE3NzE0Mjc5MTF8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    name: "Mariana Costa",
    age: 29,
    treatment: "Regeneração de Sobrancelhas",
    text: "Sempre sofri com sobrancelhas falhadas. O atendimento foi impecável e os resultados surpreendentes. Finalmente tenho as sobrancelhas que sempre sonhei!",
    rating: 5,
    image: "https://customer-assets.emergentagent.com/job_protocolo-cills/artifacts/c235k4w4_34-sobrancelha-protocolo-cills.jpg"
  },
  {
    id: 3,
    name: "Paulo Henrique",
    age: 42,
    treatment: "Regeneração de Barba",
    text: "A equipe é extremamente profissional e o resultado superou minhas expectativas. Hoje posso usar a barba que sempre quis. Recomendo de olhos fechados!",
    rating: 5,
    image: "https://customer-assets.emergentagent.com/job_protocolo-cills/artifacts/q8e7qamx_%40sbatisteli.regeneracaocapilar1.jpg"
  },
  {
    id: 4,
    name: "Ana Paula Ferreira",
    age: 38,
    treatment: "Regeneração Capilar",
    text: "Estava perdendo as esperanças até conhecer o Studio Batisteli. O Protocolo Cills devolveu meu cabelo e minha confiança. Cada sessão valeu a pena!",
    rating: 5,
    image: "https://customer-assets.emergentagent.com/job_protocolo-cills/artifacts/uqsmctbd_09-cabelo-protocolo-cills.jpg"
  },
  {
    id: 5,
    name: "Carlos Eduardo",
    age: 45,
    treatment: "Regeneração de Barba",
    text: "Tentei outros tratamentos sem sucesso. O Protocolo Cills foi diferente! Resultados visíveis já na terceira sessão. Equipe atenciosa e profissional.",
    rating: 5,
    image: "https://customer-assets.emergentagent.com/job_protocolo-cills/artifacts/fkvbeye1_07-cabelo-protocolo-cills.jpg"
  },
  {
    id: 6,
    name: "Juliana Santos",
    age: 31,
    treatment: "Regeneração de Sobrancelhas",
    text: "Minha autoestima estava lá embaixo por causa das falhas nas sobrancelhas. Hoje me sinto linda! O Studio Batisteli mudou minha vida. Super recomendo!",
    rating: 5,
    image: "https://customer-assets.emergentagent.com/job_protocolo-cills/artifacts/geo0k2z1_28-sobrancelha-protocolo-cills.jpg"
  },
  {
    id: 7,
    name: "Roberto Almeida",
    age: 50,
    treatment: "Regeneração Capilar",
    text: "Mesmo com a idade, consegui recuperar meu cabelo! O tratamento é indolor e os resultados são reais. Melhor investimento que já fiz em mim mesmo.",
    rating: 5,
    image: "https://customer-assets.emergentagent.com/job_protocolo-cills/artifacts/dgamjeev_23-cabelo-protocolo-cills.jpg"
  },
  {
    id: 8,
    name: "Camila Rodrigues",
    age: 27,
    treatment: "Regeneração de Sobrancelhas",
    text: "Procurei várias clínicas antes de encontrar o Studio Batisteli. A diferença está no atendimento personalizado e na técnica. Resultado perfeito e natural!",
    rating: 5,
    image: "https://customer-assets.emergentagent.com/job_protocolo-cills/artifacts/muqac8xp_30-sobrancelha-protocolo-cills.jpg"
  },
  {
    id: 9,
    name: "Fernando Lima",
    age: 39,
    treatment: "Regeneração de Barba",
    text: "A barba sempre foi um problema pra mim. Hoje tenho a barba cheia que sempre quis! O Studio é top, ambiente agradável e profissionais excelentes.",
    rating: 5,
    image: "https://customer-assets.emergentagent.com/job_f1640686-1f2e-4bb1-9e33-a46d25c77925/artifacts/h00asy60_barba_04_protocolo_cills.jpeg"
  },
  {
    id: 10,
    name: "Patricia Mendes",
    age: 33,
    treatment: "Regeneração Capilar",
    text: "Fiz tratamento capilar em outra clínica sem resultado. No Studio Batisteli foi completamente diferente! O Protocolo Cills realmente funciona. Estou muito feliz!",
    rating: 5,
    image: "https://customer-assets.emergentagent.com/job_f1640686-1f2e-4bb1-9e33-a46d25c77925/artifacts/ei5517ib_pexels-stockphotoartist-1097781.jpg"
  },
  {
    id: 11,
    name: "Lucas Martins",
    age: 28,
    treatment: "Regeneração de Barba",
    text: "Sempre tive complexo com as falhas na barba. O Studio Batisteli resolveu meu problema! Processo tranquilo, resultado incrível. Vale cada centavo!",
    rating: 5,
    image: "https://customer-assets.emergentagent.com/job_f1640686-1f2e-4bb1-9e33-a46d25c77925/artifacts/vt2gp2zg_pexels-olha-ruskykh-7504872.jpg"
  }
];

export const faqData = [
  {
    id: 1,
    question: "O Protocolo Cills é doloroso?",
    answer: "Não! O Protocolo Cills é totalmente não invasivo e indolor. Você pode sentir apenas uma leve sensação durante a aplicação, mas nada que cause desconforto real."
  },
  {
    id: 2,
    question: "Em quanto tempo vejo resultados?",
    answer: "Os primeiros resultados começam a aparecer a partir da 3ª sessão. O tratamento completo varia de 4 a 6 meses, dependendo do caso e da resposta individual de cada pessoa."
  },
  {
    id: 3,
    question: "O tratamento é definitivo?",
    answer: "Os resultados são duradouros e, com os cuidados adequados de manutenção recomendados pela nossa equipe, podem ser permanentes. Cada caso é avaliado individualmente."
  },
  {
    id: 4,
    question: "Quanto custa o tratamento?",
    answer: "O valor varia de acordo com a área a ser tratada e a extensão do problema. Por isso oferecemos uma avaliação gratuita para apresentar o melhor protocolo para você, com valores personalizados e parcelamento facilitado."
  },
  {
    id: 5,
    question: "Preciso me afastar das atividades do dia a dia?",
    answer: "Não há necessidade de afastamento! O Protocolo Cills não requer repouso e você pode retomar suas atividades normais imediatamente após cada sessão."
  },
  {
    id: 6,
    question: "O protocolo funciona para qualquer idade?",
    answer: "Sim! O Protocolo Cills pode ser aplicado em homens e mulheres adultos de todas as idades. Durante a avaliação a nossa equipe verifica as condições específicas de cada pessoa."
  }
];

export const contactInfo = {
  whatsapp: "5511978273924",
  whatsappFormatted: "(11) 97827-3924",
  email: "studiobatisteli@gmail.com",
  instagram: "@sbatisteli.regeneracaocapilar",
  instagramUrl: "https://instagram.com/sbatisteli.regeneracaocapilar"
};

export const formOptions = {
  services: [
    { value: "sobrancelha", label: "Regeneração de Sobrancelhas" },
    { value: "barba", label: "Regeneração de Barba" },
    { value: "cabelo", label: "Regeneração Capilar" },
    { value: "todos", label: "Quero saber sobre todos os tratamentos" }
  ],
  locations: [
    { value: "vila-mariana", label: "Vila Mariana - Segunda-Feira" },
    { value: "moema", label: "Moema - Terça-Feira" },
    { value: "tatuape", label: "Tatuapé - Quarta-feira" },
    { value: "perdizes", label: "Perdizes - Quinta-Feira" },
    { value: "paulista", label: "Paulista - Sexta-feira" },
    { value: "vila-madalena", label: "Vila Madalena - Sábado" }
  ]
};
